/* eslint-disable @typescript-eslint/no-explicit-any */
import { ButtonIcon, CardBase, setColorTheme } from '@facephi/ui-react';
import styled from 'styled-components';

export const StyledCredentialCard = styled(CardBase)<{
  $isSelected: boolean;
  $isActive: boolean;
}>`
  padding: 1.6rem;
  ${(props) =>
    props.$isSelected && `border: 1px solid ${setColorTheme('primary400')};`}
  ${(props) =>
    !props.$isActive && `border-left: 6px solid ${setColorTheme('error400')};`}
` as any;

export const StyledButton = styled(ButtonIcon)`
  margin-left: auto;
  margin-bottom: auto;
`;
